import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  FilterInputComponent,
  IconFilter,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const TextFilter = ({
  filterLabel,
  label,
  filterName,
  name,
  placeholder,
  noFilterLabel = false,
}) => {
  const { t } = useTranslation();

  return (
    <IconFilter
      as={FilterInputComponent}
      name={filterName || name}
      label={noFilterLabel ? undefined : filterLabel || label || t(name)}
      popperPlacement="top-end"
      position="bottom right"
      placeholder={placeholder}
    />
  );
};

TextFilter.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  filterName: PropTypes.string,
  filterLabel: PropTypes.string,
  placeholder: PropTypes.string,
  noFilterLabel: PropTypes.bool,
};

export default TextFilter;
